//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';


import Switch from '@material-ui/core/Switch';
//Add
import moment from 'moment';
//Part
//Dialog
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
//JSON
var packageJson = require('../../package.json');

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      saveSnackVisible: false,
    }
  }

  componentDidMount() {
    document.title = '各種設定 - パートナーズ';
    let hush = window.location.hash;
    if (hush) {
      let id = hush.replace( /#/g , '');
      let elem = document.getElementById(id);
      if (elem) {
        let rect = elem.getBoundingClientRect();
        window.scrollTo(0, (window.pageYOffset + rect.top - 50));
      }
    }
    else {
      window.scrollTo(0, 0);
    }
  }






  render() {
    let chargeBlock = null;
    let chargeContent;
    if (this.props.my.profile.userdata_sex === 'men') {
      let startDate = moment.unix(this.props.my.setting.chargeStart);
      let endDate =  moment.unix(this.props.my.setting.chargeEnd);
      let nowDate =  moment();

      if (nowDate.isBetween(startDate , endDate )) {
        chargeContent = (
          <div className='content'>
            有料サービス<br />
            <div style={{fontSize:'0.8em', fontWeight:'normal'}}>お支払い済の有料サービス期日</div>
            { endDate.format('YYYY年MM月DD日 HH時mm分') }<br />

            <div style={{marginTop:'10px', fontSize:'0.9em', fontWeight:'normal'}}>
              有料サービスの期間中に延長決済も可能です。<br />
              ご決済プランの日数分延長されるので<br />有料期間が重複して無駄にはなりません。
            </div>
            <div style={{marginTop:'10px'}}>
              <Button
                variant="outlined"
                color='primary'
                onClick={ () => this.props.history.push('/setting/charge/') }
              >
                有料サービスの延長はコチラ
              </Button>
            </div>
          </div>
        )
      }
      else if (this.props.my.setting.chargeEnd) {
        chargeContent = (
          <div className='content'>
            無料サービス<br />
            <div style={{fontWeight:'normal'}}>
              <span className='i-b'>有料サービスは</span>
              <span className='i-b'>{ endDate.format('YYYY年MM月DD日 HH時mm分') }に</span>
              <span className='i-b'>期限が満了しました</span>
            </div>
            <Button
              variant="outlined"
              color='primary'
              onClick={ () => this.props.history.push('/setting/charge/') }
            >
              有料サービスのお申し込み
            </Button>
          </div>
        )
      }
      else {
        chargeContent = (
          <div className='content'>
            無料サービス
            <Button
              variant="outlined"
              color='primary'
              onClick={ () => this.props.history.push('/setting/charge/') }
            >
              有料サービスのお申し込み
            </Button>
          </div>
        )
      }

      chargeBlock = (
        <div style={{margin:'10px 0px'}} >
          <h3 align='center'>有料サービス</h3>
          <Box boxShadow={2} style={{background:'#FFF'}}>
            <div className='settingList'>
              <div
                className='listItem'
                onClick={ () => this.props.history.push('/setting/charge/') }
                style={{cursor:'pointer'}}
              >
                <div className='left'>
                  <div className='title'>サービス状態</div>
                  { chargeContent }
                </div>
                <div className='right'>
                  <ChevronRightIcon />
                </div>
              </div>

              <Divider />


              <div
                className='listItem'
                onClick={ () => this.props.history.push('/setting/chargeAutomatic/') }
                style={{cursor:'pointer'}}
              >
                <div className='left'>
                  <div className='title'>自動更新</div>
                  <div className='content'>{ (this.props.my.setting.chargeAutomatic === 1) ? 'ON' : 'OFF' }</div>
                </div>
                <div className='right'>
                  <ChevronRightIcon />
                </div>
              </div>

            </div>
          </Box>
        </div>
      )
    }
    if (this.props.my.profile.userdata_sex === 'women') {
      chargeBlock = (
        <div style={{margin:'10px 0px'}} >
          <h3 align='center'>サービス</h3>
          <Box boxShadow={2} style={{background:'#FFF'}}>
            <div className='settingList'>

              <div
                className='listItem'
              >
                <div className='left'>
                  <div style={{padding:'10px'}}>
                    <div style={{color:'#666'}}>女性会員は全て無料でご利用いただけます。</div>
                    <div
                      style={{fontSize:'0.9em',color:'#666'}}
                      onClick={ () => this.props.guidePaymentSet(true, 'women') }
                    >
                      <u>女性の無料サービス／男性の有料と無料サービスの違いについて</u>
                    </div>
                  </div>
                </div>

              </div>


            </div>
          </Box>
        </div>
      )
    }

    return (
      <div>

        <h1 align='center'>各種設定</h1>


        <div style={{maxWidth:'600px', margin:'auto'}} id='setting_block'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'center',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div></div>
            <div>
              <span style={{color:'#666', fontSize:'0.9em'}}>バージョン {packageJson.version}</span>
              <IconButton
                onClick={ () => window.location.reload(true) }
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </div>
          <div style={{margin:'10px 0px'}}>
            <h3 align='center'>基本情報</h3>



            <Box boxShadow={2} style={{background:'#FFF'}}>
              <div className='settingList'>

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/name/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>ニックネーム</div>
                    <div className='content'>{this.props.my.profile.userdata_name}</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/birthday/')  }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>生年月日</div>
                    <div className='content'>
                      {this.props.my.profile.userdata_birthday.substr( 0, 4 )}年
                      {this.props.my.profile.userdata_birthday.substr( 4, 2 )}月
                      {this.props.my.profile.userdata_birthday.substr( 6, 2 )}日
                    </div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.setState({ sexOpen: ((this.state.sexOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>性別</div>
                    <div className='content'>
                    {
                      (this.props.my.profile.userdata_sex === 'men') ? '男性': '女性'
                    }
                    </div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.sexOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.sexOpen}>
                  <div style={{padding:'10px'}}>
                    <div>性別をお間違いの場合、<Link to='/contact/sexEdit'><u>サポート</u></Link>にお問い合わせください</div>
                  </div>
                </Collapse>

              </div>

            </Box>
          </div>

          <div id='chargeBlock'>
            { chargeBlock }
          </div>

          <div style={{margin:'10px 0px'}} id='loginBlock'>
            <h3 align='center'>ログイン</h3>
            <Box boxShadow={2} style={{background:'#FFF'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/loginId/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>ログインID</div>
                    <div className='content'>{this.props.my.setting.loginId}</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/loginPass/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>ログインパスワード</div>
                    <div className='content'>{this.props.my.setting.loginPass}</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/twoFactorAuth/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>2段階認証</div>
                    <div className='content'>{ (this.props.my.setting.twoFactorAuthentication === 1) ? 'ON' : 'OFF' }</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/googleOauth/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>Googleアカウントでログイン</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/appleOauth/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>AppleIDでログイン</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>
              </div>
            </Box>
          </div>

          <div style={{margin:'10px 0px'}} id='emailNotificationBlock'>
            <h3 align='center'>メールアドレスへの通知</h3>
            <Box boxShadow={2} style={{background:'#FFF'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/email/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>メールアドレス</div>
                    <div className='content'>
                      {(this.props.my.setting.email) ? this.props.my.setting.email : '未設定'}
                    </div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.setState({ mailNotificationOpen: ((this.state.mailNotificationOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>メール受信のお知らせ</div>
                    <div className='content'>{ (this.props.my.setting.emailNotificationMail === 1) ? '通知する' : '通知しない' }</div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.mailNotificationOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.mailNotificationOpen}>
                  <div style={{padding:'10px'}}>
                    サイト内でメールを受信した場合やベストパートナーのご紹介、サポートからのお知らせなどをメールアドレスにお知らせが届きます。
                  </div>
                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingEmailNotificationMailEdit(0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      通知しない
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingEmailNotificationMailEdit(event.target.checked ? 1 : 0) }
                        checked={ (this.props.my.setting.emailNotificationMail === 1) ? true : false }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingEmailNotificationMailEdit(1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      通知する
                    </Grid>
                  </Grid>

                </Collapse>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.setState({ favoriteNotificationOpen: ((this.state.favoriteNotificationOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>お気に入り通知のお知らせ</div>
                    <div className='content'>{ (this.props.my.setting.emailNotificationFavorite === 1) ? '通知する' : '通知しない' }</div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.favoriteNotificationOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.favoriteNotificationOpen}>
                  <div style={{padding:'10px'}}>
                    お気に入り登録(通知あり)された場合に、メールアドレスにお知らせが届きます。<br/>※前日のお気に入り通知が未読だった場合に送信されます。
                  </div>
                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingEmailNotificationFavoriteEdit(0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      通知しない
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingEmailNotificationFavoriteEdit(event.target.checked ? 1 : 0) }
                        checked={ (this.props.my.setting.emailNotificationFavorite === 1) ? true : false }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingEmailNotificationFavoriteEdit(1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      通知する
                    </Grid>
                  </Grid>
                </Collapse>


                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.setState({ memberNotificationOpen: ((this.state.memberNotificationOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>新着会員のお知らせ</div>
                    <div className='content'>{ (this.props.my.setting.emailNotificationMember === 1) ? '通知する' : '通知しない' }</div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.memberNotificationOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.memberNotificationOpen}>
                  <div style={{padding:'10px'}}>
                    地域、希望年齢に近い会員が入会された場合に登録メールアドレスにお知らせします。
                  </div>
                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingEmailNotificationMemberEdit(0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      通知しない
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingEmailNotificationMemberEdit(event.target.checked ? 1 : 0) }
                        checked={ (this.props.my.setting.emailNotificationMember === 1) ? true : false }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingEmailNotificationMemberEdit(1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      通知する
                    </Grid>
                  </Grid>

                </Collapse>

              </div>
            </Box>
          </div>


          <div style={{margin:'10px 0px'}}>
            <h3 align='center'>プッシュ通知</h3>
            <Box boxShadow={2} style={{background:'#FFF', margin:'10px 0px'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/webpush/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>通知するブラウザ</div>
                    <div className='content'>{this.props.my.setting.webpushCount}件</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                {(this.props.my.setting.webpushCount > 0) &&
                  (
                    <div>
                      <div
                        className='listItem'
                        onClick={ () => this.setState({ webpushNotificationMailOpen: ((this.state.webpushNotificationMailOpen) ? false: true) }) }
                        style={{cursor:'pointer'}}
                      >
                        <div className='left'>
                          <div className='title'>メール受信のお知らせ</div>
                          <div className='content'>{ (this.props.my.setting.webpushNotificationMail === 1) ? '通知する' : '通知しない' }</div>
                        </div>
                        <div className='right'>
                          {
                            (this.state.webpushNotificationMailOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                          }
                        </div>
                      </div>
                      <Collapse in={this.state.webpushNotificationMailOpen}>
                        <div style={{padding:'10px'}}>
                          パートナーズ内でメールを受信した場合やベストパートナーのご紹介、サポートからのお知らせなどをプッシュ通知でお知らせが届きます。
                        </div>
                        <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                          <Grid
                            item
                            onClick={ () => this.props.settingWebpushNotificationMailEdit(0) }
                            className='link'
                            style={{fontSize:'1.2em', textDecoration:'underline'}}
                          >
                            通知しない
                          </Grid>
                          <Grid item>
                            <Switch
                              onChange={ (event) => this.props.settingWebpushNotificationMailEdit(event.target.checked ? 1 : 0) }
                              checked={ (this.props.my.setting.webpushNotificationMail === 1) ? true : false }
                            />
                          </Grid>
                          <Grid
                            item
                            onClick={ () => this.props.settingWebpushNotificationMailEdit(1) }
                            className='link'
                            style={{fontSize:'1.2em', textDecoration:'underline'}}
                          >
                            通知する
                          </Grid>
                        </Grid>

                      </Collapse>

                      <Divider />

                      <div
                        className='listItem'
                        onClick={ () => this.setState({ webpushNotificationFavoriteOpen: ((this.state.webpushNotificationFavoriteOpen) ? false: true) }) }
                        style={{cursor:'pointer'}}
                      >
                        <div className='left'>
                          <div className='title'>お気に入りのお知らせ</div>
                          <div className='content'>{ (this.props.my.setting.webpushNotificationFavorite === 1) ? '通知する' : '通知しない' }</div>
                        </div>
                        <div className='right'>
                          {
                            (this.state.webpushNotificationFavoriteOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                          }
                        </div>
                      </div>
                      <Collapse in={this.state.webpushNotificationFavoriteOpen}>
                        <div style={{padding:'10px'}}>
                          お気に入り登録(通知あり)された場合に、プッシュ通知でお知らせが届きます。<br/>
                          ※前日のお気に入り通知が未読だった場合に送信されます。
                        </div>
                        <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                          <Grid
                            item
                            onClick={ () => this.props.settingWebpushNotificationFavoriteEdit(0) }
                            className='link'
                            style={{fontSize:'1.2em', textDecoration:'underline'}}
                          >
                            通知しない
                          </Grid>
                          <Grid item>
                            <Switch
                              onChange={ (event) => this.props.settingWebpushNotificationFavoriteEdit(event.target.checked ? 1 : 0) }
                              checked={ (this.props.my.setting.webpushNotificationFavorite === 1) ? true : false }
                            />
                          </Grid>
                          <Grid
                            item
                            onClick={ () => this.props.settingWebpushNotificationFavoriteEdit(1) }
                            className='link'
                            style={{fontSize:'1.2em', textDecoration:'underline'}}
                          >
                            通知する
                          </Grid>
                        </Grid>

                      </Collapse>
                    </div>
                  )
                }


              </div>
            </Box>
          </div>

          <div style={{margin:'10px 0px'}}>
            <h3 align='center'>ベストパートナーの紹介</h3>
            <Box boxShadow={2} style={{background:'#FFF', margin:'10px 0px'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.setState({ introductionOpen: ((this.state.introductionOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>紹介</div>
                    <div className='content'>{ (this.props.my.setting.introductionStop === 1) ? '紹介しない' : '紹介する' }</div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.introductionOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.introductionOpen}>
                  <div style={{padding:'10px'}}>
                    プロフィールの希望や活動状況などを考慮し、サポートよりご紹介をさせていただくサービスです。<br />
                    御紹介メールは双方に同時にお送りさせていただくので、出会いのきっかけとしてご利用いただけます。
                  </div>

                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingIntroductionEdit(1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      紹介しない
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingIntroductionEdit(event.target.checked ? 0 : 1) }
                        checked={ (this.props.my.setting.introductionStop === 1) ? false : true }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingIntroductionEdit(0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      紹介する
                    </Grid>
                  </Grid>
                  <div align='center'>

                  </div>
                </Collapse>
              </div>
            </Box>
          </div>


          <div style={{margin:'10px 0px'}} id='filterBlock'>
            <h3 align='center'>フィルタ</h3>
            <Box boxShadow={2} style={{background:'#FFF', margin:'10px 0px'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.setState({ notMatchImportantSearchOpen: ((this.state.notMatchImportantSearchOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>検索フィルタ</div>
                    <div className='content'>{ (this.props.my.setting.filterSearch === 1) ? 'ON' : 'OFF' }</div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.notMatchImportantSearchOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.notMatchImportantSearchOpen}>
                  <div style={{padding:'10px'}}>
                  <Link to='/my/partner/'><u>「パートナーへの希望(重要にチェック)」</u></Link>
                  の条件に当てあてはまらない方の会員検索ページに、あなたのプロフィールは表示されなくなります。<br />
                  (例) 希望年齢を35～45才(重要にチェック)に設定した場合、48才の方の会員検索にあなたのプロフィールは表示されません。<br />

                  ※以前の足あとやお気に入り、メモ帳などといった機能からお客様のプロフィールを閲覧する事が可能です。 徐々に、検索フィルタの効果が現れますのでお時間が経過してから再度ご確認ください。
                  </div>

                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingFilterEdit('search', 0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      OFF
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingFilterEdit('search', (event.target.checked ? 1 : 0)) }
                        checked={ (this.props.my.setting.filterSearch === 1) ? true : false }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingFilterEdit('search', 1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      ON
                    </Grid>
                  </Grid>
                </Collapse>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.setState({ notMatchImportantMailOpen: ((this.state.notMatchImportantMailOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>メールフィルタ</div>
                    <div className='content'>{ (this.props.my.setting.filterMail === 1) ? 'ON' : 'OFF' }</div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.notMatchImportantMailOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.notMatchImportantMailOpen}>
                  <div style={{padding:'10px'}}>
                    <Link to='/my/partner/'><u>「パートナーへの希望(重要にチェック)」</u></Link>
                    の条件に当てはまらない方からの受信メールは通知を送らずに、既読にすることが出来ます。<br />
                    (例) 希望年齢を35～45才(重要にチェック)に設定した場合、48才の会員様からの受信メールは受信通知を送らず、既読になります。
                  </div>
                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingFilterEdit('mail', 0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      OFF
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingFilterEdit('mail', (event.target.checked ? 1 : 0)) }
                        checked={ (this.props.my.setting.filterMail === 1) ? true : false }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingFilterEdit('mail', 1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      ON
                    </Grid>
                  </Grid>

                </Collapse>
              </div>
            </Box>
          </div>


          <div style={{margin:'10px 0px'}}>
            <h3 align='center'>ブロック・表示しない会員</h3>
            <Box boxShadow={2} style={{background:'#FFF'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/refusal/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>ブロックした会員</div>
                    <div className='content'>{this.props.my.setting.refusalCount} 件</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/nondisplay/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>表示しない会員</div>
                    <div className='content'>{this.props.my.setting.nondisplayCount} 件</div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>

              </div>

            </Box>
          </div>


          <div style={{margin:'10px 0px'}} id='accountBlock'>
            <h3 align='center'>アカウントの公開・停止</h3>
            <Box boxShadow={2} style={{background:'#FFF'}}>
              <div className='settingList'>
                <div
                  className='listItem'
                  onClick={ () => this.setState({ searchOpen: ((this.state.searchOpen) ? false: true) }) }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>検索結果への表示</div>
                    <div className='content'>{(this.props.my.setting.searchPublish) ? '表示する' : '非表示' } </div>
                  </div>
                  <div className='right'>
                    {
                      (this.state.searchOpen) ? <ExpandLessIcon />: <ExpandMoreIcon />
                    }
                  </div>
                </div>
                <Collapse in={this.state.searchOpen}>
                  <div style={{padding:'10px'}}>
                    あなたのアカウントを検索結果に表示するか設定できます。
                    <div>※表示しないに設定しても、以前のメール、足あと等の既存のつながりからプロフィールは閲覧できます。</div>
                  </div>
                  <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                    <Grid
                      item
                      onClick={ () => this.props.settingSearchPublishEdit(0) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      非表示
                    </Grid>
                    <Grid item>
                      <Switch
                        onChange={ (event) => this.props.settingSearchPublishEdit((event.target.checked ? 1 : 0)) }
                        checked={ (this.props.my.setting.searchPublish === 1) ? true : false }
                      />
                    </Grid>
                    <Grid
                      item
                      onClick={ () => this.props.settingSearchPublishEdit(1) }
                      className='link'
                      style={{fontSize:'1.2em', textDecoration:'underline'}}
                    >
                      表示する
                    </Grid>
                  </Grid>

                </Collapse>

                <Divider />

                <div
                  id='timeline'
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/timeline/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>タイムラインへの表示</div>
                    <div className='content'>{(this.props.my.setting.timeline) ? '表示する' : '非表示' } </div>
                  </div>
                  <div className='right'>
                    <ChevronRightIcon />
                  </div>
                </div>


                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/stop/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>サービスの停止</div>
                    <div className='content'>{(this.props.my.setting.serviceStop) === 1 ? '停止' : '稼働中'} </div>
                  </div>

                  <div className='right'>
                    <ChevronRightIcon />
                  </div>

                </div>

                <Divider />

                <div
                  className='listItem'
                  onClick={ () => this.props.history.push('/setting/outage/') }
                  style={{cursor:'pointer'}}
                >
                  <div className='left'>
                    <div className='title'>退会</div>
                  </div>

                  <div className='right'>
                    <ChevronRightIcon />
                  </div>

                </div>

              </div>
            </Box>
          </div>


        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...uiAction,
    ...myProfileAction,
    ...settingAction,
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
